import type {
    LeadDripSequencesFragment,
    EmailAutomationStatusesFragment,
    GetLeadPersonalEmailSequences_lead_stages as LeadStages,
} from 'nutshell-graphql-types';

export function getLeadDripContacts(dripSequences?: LeadDripSequencesFragment | null) {
    if (!dripSequences || !dripSequences.contacts || !dripSequences.contacts.edges) {
        return [];
    }

    return dripSequences.contacts.edges
        .filter((edge) => edge.node && edge.node.dripProgressions)
        .map((edge) => edge.node);
}

export function extractEmailAutomationStatuses(
    stages?: LeadStages | null
): EmailAutomationStatusesFragment[] {
    if (!stages || !stages.edges) return [];

    const statuses: EmailAutomationStatusesFragment[] = [];

    stages.edges.forEach((stageEdge) => {
        if (stageEdge.isActive && stageEdge.emailAutomationStatuses) {
            stageEdge.emailAutomationStatuses.forEach((status) => {
                statuses.push(status);
            });
        }
    });

    return statuses;
}
